import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SEKMELER = [
  { id: "/", icon: "🏠", labelKey: "nav.home" },
  { id: "/fallarim", icon: "📜", labelKey: "nav.myReadings" },
  { id: "/falcilar", icon: "🧿", labelKey: "nav.readers" },
  { id: "/profil", icon: "👤", labelKey: "nav.profile" },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div style={{
      position: "fixed", bottom: 0, left: "50%", transform: "translateX(-50%)",
      width: "100%", maxWidth: 420,
      background: "rgba(10,7,24,0.92)", backdropFilter: "blur(20px)",
      borderTop: "1px solid rgba(255,255,255,0.08)",
      padding: "12px 0 20px", display: "flex", justifyContent: "space-around", zIndex: 100,
    }}>
      {SEKMELER.map((sekme) => {
        const aktif = location.pathname === sekme.id;
        return (
          <button key={sekme.id} onClick={() => navigate(sekme.id)} style={{
            background: "none", border: "none", cursor: "pointer",
            display: "flex", flexDirection: "column", alignItems: "center",
            gap: 4, padding: "4px 16px", borderRadius: 12,
          }}>
            <div style={{
              fontSize: 22,
              filter: aktif ? "none" : "grayscale(1) opacity(0.5)",
              transform: aktif ? "scale(1.15)" : "scale(1)",
              transition: "all 0.2s",
            }}>
              {sekme.icon}
            </div>
            <div style={{
              fontSize: 10, fontWeight: 600,
              color: aktif ? "rgba(200,170,255,0.9)" : "rgba(255,255,255,0.3)",
              letterSpacing: 0.3, transition: "color 0.2s",
            }}>
              {t(sekme.labelKey)}
            </div>
          </button>
        );
      })}
    </div>
  );
}